import { useEffect } from "react";
import { useMap } from "react-leaflet";

import { Cursor } from "../../types/all";

export const MapCursor = ({ cursor = "grab" }: { cursor?: Cursor }) => {
  const map = useMap();
  useEffect(() => {
    const container = map.getContainer();
    container.style.cursor = cursor;
    return () => {
      container.style.cursor = "";
    };
  }, [cursor, map]);
  return null;
};
